// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3z5dH","footer":"ModalCreateQualiphyProcedure_footer__2lqDa","additionData":"ModalCreateQualiphyProcedure_additionData__28aDA"};